export default class EmrLoginModule {
    provides() {
        return {
            'root-routes': [() => require('./index').LoginRootRoutes],
        };
    }
}
